import { apiClient, Auth } from '@/shared/api'

import { TRoomFeeInfo } from '../model/schema'

export type RoomFeeInfoParams = {
  roomId: number
}

export const getRoomFeeInfo = async ({ roomId }: RoomFeeInfoParams) => {
  const { data } = await apiClient.get<TRoomFeeInfo>({
    endpoint: `/host/rooms/${roomId}/fee-info`,
    auth: Auth.REQUIRED,
  })

  return data
}
